import {Button, Form, Input, Modal, notification, Select} from "antd";
import {MobileOutlined, PhoneOutlined} from "@ant-design/icons";
import Request from "../../utilis/api/Request";
import React, {useContext, useState} from "react";
import AuthContext from "../../utilis/contexts/AuthContext";
import {Validation, BillingReviewValidation} from "../../utilis/tools/validation";
import Urls from "../../utilis/api/Urls";
import AppContext from "../../utilis/contexts/AppContext";
import ValueLabel from "../../utilis/models/valueLabel";
import AuthenticatedForm from "./AuthenticatedForm";
import DefaultForm from "./DefaultForm";
import {ConvertPersianToEnglish} from "../../utilis/helpers/convertor";
import Texts from "../../utilis/defaults/Text";
import ServiceResponseTime from "../../utilis/enums/ServiceResponseTime";
import ResponseMessageHandler from "../../utilis/helpers/ResponseMessage";
import Text from "../../utilis/defaults/Text";
import AbfaLogo from "../../images/logo.png"
import ConfirmInfoModal from "../modals/ConfirmInfoModal";

const BillingReview = () => {
    const authContext = useContext(AuthContext);
    const appContext = useContext(AppContext);
    const {globalData} = appContext;
    // @ts-ignore
    const {billing_review_types} = globalData;
    // @ts-ignore
    const token = authContext.authenticated ? null : authContext.data.token;
    // @ts-ignore
    const [data, setData] = useState(authContext.authenticated ? authContext.data : authContext.data.data);
    const {Option} = Select;
    const [reviewType, setReviewType] = useState('');
    const [isLoading, setLoading] = useState(false);
    const handlePrint = (text: string, name: string, traceNumber: string, address: string, orderType: string, mobile: string) => {
        // @ts-ignore

        // @ts-ignore
        var newWin = window.open('', '', 'height=650, width=650');
        // @ts-ignore
        newWin.document.write('');
        // @ts-ignore

        // @ts-ignore
        newWin.document.write(`
            <div style="margin-bottom: 4px;display: flex; justify-content: center;font-family:'iranSans';"><h3>اداره آب و فاضلاب مازندران</h3></div>
            <div style="border: 1px solid #5e5d5d;border-radius: 7px">
                        <p style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">${text}
        </p>
     
                <div style="direction:rtl;display: flex;justify-content: start;flex-wrap: wrap;font-family:'iranSans';">
                 <span style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">نام و نام خانوادگی : ${name}</span>
                 <span style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">کد رهگیری : ${traceNumber}</span>
                 <span style="padding: 10px;font-family:'iranSans';">نوع درخواست : ${orderType}</span>
                 <span style="padding: 10px;font-family:'iranSans';">موبایل : ${mobile}</span>
                 <span style="padding: 10px;font-family:'iranSans';">آدرس : ${address}</span>
        </div>
            </div>
                            <div style="display: flex;justify-content: center;align-items: center;">
            <img style="width:250px;height: auto;margin-top: 50px; opacity: 80%" src="${AbfaLogo}" alt="">
</div>
        `);
        // @ts-ignore

        // @ts-ignore
        // @ts-ignore
        newWin.document.close();
        // @ts-ignore
        newWin.print();
    }
    const handleSubmit = (values: any) => {

        if (reviewType === '') {
            notification['error']({
                message: 'خطا',
                description: 'لطفا نوع بررسی را وارد کنید',
                duration: 120
            });
            return
        }
        const body = {
            "Token": token,
            "Cellphone": authContext.authenticated ? authContext.user.cellphone : data.cellphone,
            "NationalCode": authContext.authenticated ? ConvertPersianToEnglish(values.nationalCode) : data.national_code,
            "PostalCode": authContext.authenticated ? ConvertPersianToEnglish(values.postalCode) : data.postal_code,
            "TelNumber": ConvertPersianToEnglish(values.tel),
            "MobileNumber": ConvertPersianToEnglish(values.mobile),
            "FileNumber": authContext.authenticated ? authContext.currentFileNumber : data.file_number,
            "FirstName": data.first_name,
            "LastName": data.last_name,
            "City": authContext.authenticated ? data.city_id : data.city,
            "Email": authContext.authenticated ? values.email : "",
            "Address": values.address ? values.address : data.address,
            "Description": authContext.authenticated ? values.description : data.description,
            "BillingReviewType": reviewType.toString()
        }
        const currentType = billing_review_types.filter((type: any) => type.value == reviewType);

        const modalData = {
            ...body,
            CityName: data.city_name,
            BillingReviewTypeName: currentType && currentType.length > 0 ? currentType[0].label : "",
        }
        Modal.confirm({
            direction: "rtl",
            title: 'آیا از صحت اطلاعات اطمینان دارید؟',
            content: <ConfirmInfoModal
                data={modalData}
                type={"BillingReview"}/>,
            onOk: () => handleRequest(body, values),
            closable: true,
            centered: true,
            okText: "تایید و ارسال",
            cancelText: "بستن",
            width: 800,
        })

    }
    const handleRequest = (body: any, values: any) => {
        setLoading(true)
        Request(Urls.BillingReview, body).then((response: any) => {
            const key = `open${Date.now()}`;

            notification['success']({
                message: response.message,
                description: ResponseMessageHandler(ServiceResponseTime.BillingReview, response.data.trace_number),
                duration: 120,
                key: key,
                btn: <Button type="primary" size="small" onClick={() => {
                    handlePrint(ResponseMessageHandler(ServiceResponseTime.BillingReview, response.data.trace_number), data.first_name + " " + data.last_name, response.data.trace_number, body.Address, Text.BillingReview, values.mobile);
                    notification.destroy()
                }}>
                    چاپ
                </Button>
            });
        }).catch(() => {

        }).finally(() => {
            setLoading(false)
        })

    }
    const handleReviewChange = (value: string) => {
        setReviewType(value)
    };
    const onFinishFailed = (error: any) => {

    }
    return <Form
        name="basic"
        className="w-full flex flex-col"
        layout='vertical'
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        scrollToFirstError={true}
    >

        {authContext.authenticated && <AuthenticatedForm validationSchema={BillingReviewValidation} data={data}/>}
        <Form.Item label="نوع بررسی">
            <Select size="large" defaultValue="" className="w-full" onChange={handleReviewChange}>
                <>
                    {billing_review_types.map((reviewType: ValueLabel) => <Option key={reviewType.value}
                                                                                  value={reviewType.value}>
                        {reviewType.label}
                    </Option>)}
                </>
            </Select>
        </Form.Item>
        <DefaultForm validationSchema={BillingReviewValidation} data={data}/>

        <Form.Item className="w-full mt-4">
            <Button loading={isLoading} size="large" type="primary" className="bg-primary w-full  md:w-[150px]"
                    htmlType="submit">
                ثبت درخواست
            </Button>
        </Form.Item>

    </Form>
}
export default BillingReview;